// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-players-filter-modal.modal2 {
    bottom: unset;
}

.home-players-filter-modal .modal2__container {
    margin: 0;
    height: 100%;
    border-radius: 0;
}

.home-players-filter-modal .modal2__content {
    height: 100vh;
    position: inherit;
}

.home-players-filter-modal__mobile-submit-buttons{
    position: fixed;
    bottom: 0;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: -webkit-fill-available;
    background: var(--white-color);
    border-top: 1px solid var(--new-gray-color);
}

.home-players-filter-modal__mobile-submit-buttons .button {
    width: 156px;
}

.home-players-filter-modal__filter {
    padding: 16px 20px;
}

.home-players-filter-modal__filter .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.home-players-filter-modal__option-button .MuiFormControlLabel-root .MuiIconButton-root {
    padding: 6px 0;
    margin-right: 12px;
}

.home-players-filter-modal__option-button .MuiFormControlLabel-root {
    margin: 0;
    width: 100%;
    /* margin-top: 12px; */
    
}

.home-players-filter-modal__option-button .baloa-names {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.home-players-filter-modal__checkbox .baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.home-players-filter-modal__checkbox .Mui-selected .baloa-names {
    color: var(--new-green-color);
}

.home-players-filter-modal__checkbox {
    margin: 0;
    width: 100%;
    margin-top: 12px;
}

.home-players-filter-modal__checkbox .MuiToggleButton-root.Mui-selected + .MuiToggleButton-root.Mui-selected {
    border-left: 1px solid var(--new-green-color);
    margin-left: 6px;
}

.home-players-filter-modal__container {
    margin-top: 24px;
    margin-bottom: 92px;
}

.home-players-filter-modal__natiolocation.input-field-auto-search {
    margin: 22px 0 0 0;
}

.home-players-filter-modal__natiolocation .MuiAutocomplete-root {
    border-radius: 5px;
    border: 1px solid var(--new-gray-background-color);
    /* background: var(--new-background-color); */
}

.home-players-filter-modal__natiolocation .MuiListItem-gutters {
    padding-left: 8px;
}

.home-players-filter-modal__natiolocation .input-field-autocomplete-search input {
    margin-left: 8px;
}

.home-players-filter-modal__natiolocation .input-field-autocomplete-search label{
    padding: 0;
}

.home-players-filter-modal__filter-param {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 12px 20px;
}

.home-players-filter-modal__switch.MuiFormControlLabel-root {
    margin-left: 0;
}

.home-players-filter-modal__option-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
}

.home-players-filter-modal__option-buttons .option-button {
    padding: 4px 6px;
    border-radius: 25px;
    color: var(--basic-gray-color);
    background: var(--white-color);
    border: 1px solid var(--basic-gray-color);
    cursor: pointer;
}

.home-players-filter-modal__option-buttons .option-button.selected {
    color: var(--new-green-color);
    background: #EAF7F0;
    border: 1px solid var(--new-green-color);
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-players-filter/HomePlayersFilterModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,sBAAsB;;AAE1B;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;IAC9B,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,wCAAwC;AAC5C","sourcesContent":[".home-players-filter-modal.modal2 {\n    bottom: unset;\n}\n\n.home-players-filter-modal .modal2__container {\n    margin: 0;\n    height: 100%;\n    border-radius: 0;\n}\n\n.home-players-filter-modal .modal2__content {\n    height: 100vh;\n    position: inherit;\n}\n\n.home-players-filter-modal__mobile-submit-buttons{\n    position: fixed;\n    bottom: 0;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: -webkit-fill-available;\n    background: var(--white-color);\n    border-top: 1px solid var(--new-gray-color);\n}\n\n.home-players-filter-modal__mobile-submit-buttons .button {\n    width: 156px;\n}\n\n.home-players-filter-modal__filter {\n    padding: 16px 20px;\n}\n\n.home-players-filter-modal__filter .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.home-players-filter-modal__option-button .MuiFormControlLabel-root .MuiIconButton-root {\n    padding: 6px 0;\n    margin-right: 12px;\n}\n\n.home-players-filter-modal__option-button .MuiFormControlLabel-root {\n    margin: 0;\n    width: 100%;\n    /* margin-top: 12px; */\n    \n}\n\n.home-players-filter-modal__option-button .baloa-names {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.home-players-filter-modal__checkbox .baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.home-players-filter-modal__checkbox .Mui-selected .baloa-names {\n    color: var(--new-green-color);\n}\n\n.home-players-filter-modal__checkbox {\n    margin: 0;\n    width: 100%;\n    margin-top: 12px;\n}\n\n.home-players-filter-modal__checkbox .MuiToggleButton-root.Mui-selected + .MuiToggleButton-root.Mui-selected {\n    border-left: 1px solid var(--new-green-color);\n    margin-left: 6px;\n}\n\n.home-players-filter-modal__container {\n    margin-top: 24px;\n    margin-bottom: 92px;\n}\n\n.home-players-filter-modal__natiolocation.input-field-auto-search {\n    margin: 22px 0 0 0;\n}\n\n.home-players-filter-modal__natiolocation .MuiAutocomplete-root {\n    border-radius: 5px;\n    border: 1px solid var(--new-gray-background-color);\n    /* background: var(--new-background-color); */\n}\n\n.home-players-filter-modal__natiolocation .MuiListItem-gutters {\n    padding-left: 8px;\n}\n\n.home-players-filter-modal__natiolocation .input-field-autocomplete-search input {\n    margin-left: 8px;\n}\n\n.home-players-filter-modal__natiolocation .input-field-autocomplete-search label{\n    padding: 0;\n}\n\n.home-players-filter-modal__filter-param {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 12px 20px;\n}\n\n.home-players-filter-modal__switch.MuiFormControlLabel-root {\n    margin-left: 0;\n}\n\n.home-players-filter-modal__option-buttons {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 16px;\n}\n\n.home-players-filter-modal__option-buttons .option-button {\n    padding: 4px 6px;\n    border-radius: 25px;\n    color: var(--basic-gray-color);\n    background: var(--white-color);\n    border: 1px solid var(--basic-gray-color);\n    cursor: pointer;\n}\n\n.home-players-filter-modal__option-buttons .option-button.selected {\n    color: var(--new-green-color);\n    background: #EAF7F0;\n    border: 1px solid var(--new-green-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
